<template>
  <div class="p-question__footer" ref="refFooter" :key="isOpen.toString()">
    <div class="c-accordion" ref="refAccordion">
      <div class="c-accordion__cont" :class="{'is-open':isOpen}">
        <div class="p-question__footer__title" v-if="fromJudgePage"><span class="tag">解答例</span>を見て答え合わせをしよう</div>
        <div class="p-question__footer__inner">
          <slot name="helpTag"></slot>
          <slot name="prevButton"></slot>
          <slot name="answerList"></slot>
          <slot name="answerButton"></slot>
        </div>
        <slot name="questionId"></slot>
      </div>

      <div class="c-accordion__btn" :class="{'is-open':isOpen}">
        <div class="c-accordion__btn__inner" @click="open" :name="`${pageName}-accordion-btn`">
          <div class="c-accordion__btn__inner__box">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, nextTick} from 'vue'
  
  const isOpen = ref(true)
  const verticalAccordionWidth = ref(0)
  const refFooter = ref<HTMLInputElement | null>(null)
  const refAccordion = ref<HTMLInputElement | null>(null)

  const props = withDefaults(
    defineProps<{
      fromJudgePage?: boolean;
      isVertical?: boolean;
      questionPage?: boolean;
      pageName?: string;
    }>(),
    {
      fromJudgePage: false,
      isVertical: false,
      questionPage: false,
      pageName: '',
    }
  );
  
  const emit = defineEmits<{
    (e: 'body-height'): void
  }>()

  onMounted(() => {
    nextTick(function () {
      if(props.isVertical){ // 縦書きの時フッターとアコーディオン幅が違う問題があるので別の処理をする。NFR-2618対応
        accordionWidth()
      }
      // adjust body height after render
      emit("body-height")
    })
  })
  
  // ipadでフッターとアコーディオン幅が違って画面にはみ出すことがある。それを同じく調整する。PCはいつも両方幅が同じなのでこの処理を一緒に使っても問題ない。
  function accordionWidth(){
    setTimeout(()=>{
      if(refFooter.value && refAccordion.value && refFooter.value.clientWidth != refAccordion.value.clientWidth){ // 普通はフッターとアコーディオン幅が同じことが正しいか、ipadだけ違う場合がある。それを同じく設定
        refFooter.value.style.width = refAccordion.value.style.width = refAccordion.value.clientWidth + 'px'
      }
      verticalAccordionWidth.value = refAccordion.value?.clientWidth || 0 // アコーディオン開閉の時使うためアコーディオン幅を保存
    },20)
  }
  function open() {
    isOpen.value = !isOpen.value
    if (props.isVertical) {
      if (!isOpen.value) {
        refFooter.value.removeAttribute('style')
        refAccordion.value.removeAttribute('style')
      }else{
        refFooter.value.style.width = refAccordion.value.style.width = verticalAccordionWidth.value + 'px'
      }
    }
    emit("body-height")
  }
</script>
